import { z } from 'zod';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';

/**
 * Auth surface (T-0010 Entra ID firm-team SSO + T-0011 magic-link
 * redeem for client-viewers).
 *
 * `/api/v1/auth/magic-link/redeem` is the only auth endpoint the API
 * currently exposes — it's the public redeem path for the client-viewer
 * magic-link flow. There is **no** firm-team login endpoint; firm-team
 * users authenticate via Entra ID and arrive at the SPA with a bearer
 * token already in hand. For local dev the README documents the
 * dev-admin shortcut.
 */

export const RedeemMagicLinkResultSchema = z
  .object({
    grant_id: z.string().uuid().optional(),
    viewer_email: z.string().email().optional(),
    engagement_id: z.string().uuid().optional(),
    expires_at: z.string().optional(),
  })
  .passthrough();
export type RedeemMagicLinkResult = z.infer<typeof RedeemMagicLinkResultSchema>;

export interface RedeemMagicLinkInput {
  token: string;
}

export function redeemMagicLink(input: RedeemMagicLinkInput): Promise<RedeemMagicLinkResult> {
  return apiClient('/api/v1/auth/magic-link/redeem', RedeemMagicLinkResultSchema, {
    method: 'POST',
    body: input,
    noAuth: true,
  });
}

export function useRedeemMagicLinkMutation() {
  return useMutation({
    mutationFn: (input: RedeemMagicLinkInput) => redeemMagicLink(input),
  });
}
